import React from 'react';
import PageTemplate from '../../components/PageTemplate';

const ITConsulting = () => {
  return (
    <PageTemplate
      title="IT Consulting"
      subtitle="Strategic technology consulting to drive digital transformation"
      breadcrumb="Services > IT Consulting"
    >
      <div className="content-section">
        <h3>Technology Consulting Services</h3>
        <p>Strategic guidance for technology decisions, digital transformation, and legacy system modernization.</p>
      </div>
    </PageTemplate>
  );
};

export default ITConsulting; 